module.exports = __webpack_public_path__ + "img/builder-13.d6364dce.jpg";